import { render, staticRenderFns } from "./corruptedTransactions.vue?vue&type=template&id=4bba3692&"
import script from "./corruptedTransactions.vue?vue&type=script&lang=js&"
export * from "./corruptedTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports